import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createAccount, updateAccount, getAllAccounts } from "./AccountService";

export default function AccountForm(){
  const [accountName,setAccountName]=useState("ICICI_SAVINGS");
  const [accountType,setAccountType]=useState("BANK");
  const [balance,setBalance]=useState(0);
  const [active,setActive]=useState(true);
  const [accountNumber, setAccountNumber]=useState('');
  const [comment, setComment]=useState('');

  const {id}=useParams();
  const nav=useNavigate();

  useEffect(()=>{
    if(id) load();
  },[id]);

  const load = async ()=>{
    const all = await getAllAccounts();
    const a = all.find(x=>x.id===id);
    if(a){
      setAccountName(a.accountName);
      setAccountType(a.Type);
      setBalance(a.currentBalance);
      setActive(a.isActive);
      setAccountNumber(a.accountNumber);
      setComment(a.comment);
    }
  };

  const submit = async (e)=>{
    e.preventDefault();

    if (!accountNumber || !accountNumber.trim()) {
      return;
    }

    if(id){
      await updateAccount(id, accountName, accountType, balance, active, accountNumber, comment);
    }else{
      await createAccount(accountName, accountType, balance, accountNumber, comment);
    }

    nav("/expense/accounts");
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>{id ? "Edit Account":"Add Account"}</h3>

      <input 
        value={accountName}
        onChange={e=>setAccountName(e.target.value)}
        placeholder="Account Name"
        required
      />

      <select value={accountType} onChange={e=>setAccountType(e.target.value)}>
        <option value="BANK">SAVINGS</option>
        <option value="CASH">CASH</option>
        <option value="CREDIT_CARD">CREDIT</option>
        <option value="WALLET">WALLET</option>
        <option value="LOAN_ACCOUNT">INVESTMENT</option>
        <option value="UPI">UPI</option>
      </select>

      <input 
        type="number"
        value={balance}
        onChange={e=>setBalance(e.target.value)}
        placeholder="Initial Balance"
      />

      <input value={accountNumber}
      onChange={e=>setAccountNumber(e.target.value)}
      placeholder="account number"
      required
      />

      <input 
      value={comment}
      onChange={e=>setComment(e.target.value)}
      placeholder="comment"
      />

      <label className="inline-checkbox">
        <input type="checkbox" checked={active} onChange={e=>setActive(e.target.checked)} />
        Active
      </label>

      <button className="btn btn-primary" type="submit">Save</button>
    </form>
  );
}
